export default __webpack_public_path__ + "static/media/cover.24cdab94.jpg";